package se.mittpass.shared.repository

import io.ktor.client.*
import io.ktor.client.call.body
import io.ktor.client.request.*
import io.ktor.http.*
import se.mittpass.shared.api.CreateSlotRequest
import se.mittpass.shared.api.SlotDto
import se.mittpass.shared.api.UpdateSlotRequest

class SlotsRepository(private val httpClient: HttpClient) {
    suspend fun getSlotsForWeek(workplaceId: Long, weekStart: String): Result<List<SlotDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/slots") {
            parameter("week", weekStart)
        }.body()
    }

    suspend fun getSlotsForRange(workplaceId: Long, from: String, to: String): Result<List<SlotDto>> = runCatching {
        httpClient.get("workplaces/$workplaceId/slots") {
            parameter("from", from)
            parameter("to", to)
        }.body()
    }

    suspend fun createSlot(workplaceId: Long, req: CreateSlotRequest): Result<Long> = runCatching {
        val response = httpClient.post("workplaces/$workplaceId/slots") {
            setBody(req)
        }
        val body = response.body<Map<String, Long>>()
        body["id"]!!
    }

    suspend fun updateSlot(slotId: Long, req: UpdateSlotRequest): Result<Unit> = runCatching {
        httpClient.put("slots/$slotId") {
            setBody(req)
        }
    }

    suspend fun assignSlot(slotId: Long, req: se.mittpass.shared.api.AssignSlotRequest): Result<Unit> = runCatching {
        httpClient.post("slots/$slotId/assign") {
            setBody(req)
        }
    }

    suspend fun deleteSlot(slotId: Long): Result<Unit> = runCatching {
        httpClient.delete("slots/$slotId")
    }

    suspend fun generateBulkSchedule(workplaceId: Long, req: se.mittpass.shared.api.GenerateBulkScheduleRequest): Result<Int> = runCatching {
        val response = httpClient.post("workplaces/$workplaceId/slots/generate-bulk") {
            setBody(req)
        }
        val body = response.body<Map<String, Int>>()
        body["createdCount"] ?: 0
    }
}
